import camelCase from "lodash/camelCase";
const DIVIDERS_REGEXP = /[\s-]+/gu;
var pascal_case_default = (str) => {
  const camelCased = camelCase(str.replace(DIVIDERS_REGEXP, "_"));
  return camelCased.substring(0, 1).toUpperCase() + camelCased.substring(1);
};
export {
  pascal_case_default as default
};
